import React, { useEffect } from 'react'
import { privacyActions } from '../../store/actions'
import { connect } from 'react-redux'

// import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer'
// import '@toast-ui/editor/dist/toastui-editor-viewer.css'

const PrivacyMaster = (props) => {
  const viewer = document.querySelector('#viewer')

  useEffect(() => {
    props.load()
  }, [])
   useEffect(() => {
      if(props.privacyPage === true){
        props.priOptionSetting(
          props?.privacy?.data?.ptlTerms

        )
        props.optionSettings(
          props?.privacy?.data?.trmsHit

        )
      }else{

      }

    }, [props])

    let trmsCn = props?.privacy?.data?.trmsCn?.replaceAll('& ', '&')
    let trmsHit = "";

    useEffect(() => {
      for(var i in props?.privacy?.data?.trmsHit){

        if(props?.privacy?.data?.trmsHit[i].trmsSeq === props.select){
          trmsHit = props?.privacy?.data?.trmsHit[i].trmsCn.replaceAll('& ', '&')
        }
      }
    }, [props.select])


//     if (viewer !== null && viewer !== undefined) {
//        viewer.innerHTML = trmsCn
//    }
    useEffect(() => {
      if (viewer !== null && viewer !== undefined) {
         if(props.select?.length >= 1){
           viewer.innerHTML = decodeHTMLEntities(trmsHit)
         }else{
           viewer.innerHTML = decodeHTMLEntities(trmsCn)
         }
      }
    }, [props])

    return (
      <React.Fragment>
        <div id="viewer"></div>
      </React.Fragment>
    )
  }

  function decodeHTMLEntities(str) {
    let element = document.createElement('div')
    if (str && typeof str === 'string') {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '')
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '')
      element.innerHTML = str
      str = element.textContent
      element.textContent = ''
    }

    return str
  }

  const mapStateToProps = (state) => {
    return { privacy: state.privacy }
  }

  const actionCreators = {
    load: privacyActions.load,
  }

  export default connect(mapStateToProps, actionCreators)(PrivacyMaster)

